import { render, staticRenderFns } from "./BlackList.vue?vue&type=template&id=4630df40&scoped=true&"
import script from "./BlackList.vue?vue&type=script&lang=js&"
export * from "./BlackList.vue?vue&type=script&lang=js&"
import style0 from "./BlackList.vue?vue&type=style&index=0&id=4630df40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4630df40",
  null
  
)

export default component.exports